import { WebXRPresentingMessage } from "../../messages/xr/WebXRMessages";
import { busService } from "../bus";
import { MulticastDelegate2 } from "flavr-common";
import { camera } from "../rendering/camera";
class XRService {
    constructor() {
        this.connection = busService.connection("XRService");
        this._isPresenting = false;
        this.onPresentingChangedDelegate = new MulticastDelegate2();
        this.handleWebXRPresentingMessage = (msg) => {
            this._isPresenting = msg.isPresenting;
            // set fov to 45 when presenting because somehow it's not set correctly after vr session
            if (!this._isPresenting) {
                camera.perspectiveCam.fov = 45;
            }
            this.onPresentingChangedDelegate.invoke(this._isPresenting, msg.position);
        };
        this.connection.subscribeByType(WebXRPresentingMessage, this.handleWebXRPresentingMessage);
    }
    isPresenting() {
        return this._isPresenting;
    }
}
export const xrService = new XRService();
